<!--
 * @Author: scg
 * @Date: 2021-12-27 13:41:34
 * @LastEditTime: 2022-03-15 18:41:54
 * @LastEditors: scg
 * @Description:
-->
<template>
  <div class="fff" ref="fff">
    <div class="Browser_title" style="width: 100%">{{$t('website.txt1')}}</div>
    <div style="display: flex" :style="{ 'min-height': height }">
      <div class="Website">
        <div class="Website_con">
          {{$t('website.txt2')}}
        </div>
        <div class="Website_li">
          <div class="Browser_title" style="border-bottom: none">
            {{$t('website.txt3')}}
          </div>
          <input
            v-model="webUrl"
            :placeholder="$t('Enter a web address(ex:facebook.com)')"
          />
          <div @click="addlist()" class="loginButton">{{$t('website.txt4')}}</div>
        </div>
      </div>
      <div class="Browser_ul">
        <div class="Browser_title" style="border-bottom: none">
          {{$t('website.txt5')}}
        </div>
        <div class="Browser_li" v-for="(val, key) in list" :key="key">
          <img src="@/assets/img/web.png" />
          {{ val.web_url }}<span @click="delist(val.id)">{{$t('website.txt6')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BlockcontrolInsertSite,
  BlockcontrolGetWebsite,
  BlockcontrolDelete
} from '@/api/user'

export default {
  name: 'HelloWorld',
  data () {
    return {
      list: [],
      webUrl: '',
      msg: '',
      height: 0
    }
  },
  mounted () {
    this.getlist()
    this.$nextTick(() => {
      this.height = `calc(${this.$refs.fff.clientHeight}px - 66px)`
    })
  },
  methods: {
    getlist () {
      var key = {
        equipment_id: localStorage.getItem('systemId'),
        page: 1,
        limit: 9999
      }
      BlockcontrolGetWebsite(key).then((qwe) => {
        this.list = qwe.data.list
      })
    },
    addlist () {
      if (!this.webUrl || !/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/.test(this.webUrl) ) {
          this.$message.error(this.$t('Enter a web address'))
					return
				}
      var key = {
        equipment_id: localStorage.getItem('systemId'),
        web_url: this.webUrl
      }
      BlockcontrolInsertSite(key).then((qwe) => {
        if (qwe.code !== 1) {
          this.$message.error(qwe.msg)
        }
        this.webUrl = ''
        this.getlist()
      })
    },
    delist (a) {
      var key = {
        equipment_id: localStorage.getItem('systemId'),
        id: a
      }
      BlockcontrolDelete(key).then((qwe) => {
        this.getlist()
      })
    }
  }
}
</script>

<!-- Add "scope
d" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 97%;
  margin: 20px auto;
  background: #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  overflow: hidden;
  padding-bottom: 0;
  /* padding-bottom: 60px; */
}
.Browser_ul {
  float: right;
  width: 60%;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkI4MjY3MTY2RUM0QjExRUJCMURBRjY2RUE2NDY1NzU4IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkI4MjY3MTY3RUM0QjExRUJCMURBRjY2RUE2NDY1NzU4Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QjgyNjcxNjRFQzRCMTFFQkIxREFGNjZFQTY0NjU3NTgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QjgyNjcxNjVFQzRCMTFFQkIxREFGNjZFQTY0NjU3NTgiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5HVGmWAAAAD0lEQVR42mJ4+PgZQIABAAVTAqu9pHiVAAAAAElFTkSuQmCC)
    0 repeat-y;
  padding-bottom: 60px;
}
.Browser_title {
  line-height: 55px;
  padding-top: 10px;
  height: 55px;
  text-indent: 2.5%;
  font-weight: 700;
  border-bottom: 1px solid #e1e3e6;
  font-size: 14px;
  color: #000927;
}
.Browser_time {
  margin-top: 20px;
  line-height: 20px;
  height: 20px;
  font-size: 14px;
  color: #000927;
  text-indent: 2.5%;
}
.Browser_li {
  width: 95%;
  margin-left: 2.5%;
  border-bottom: 1px solid #e1e3e6;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  color: #000927;
  overflow: hidden;
}
.Browser_li div {
  float: left;
  width: 90px;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  color: #9f9f9f;
}
.Browser_li img {
  float: left;
  width: 20px;
  height: 20px;
  display: block;
  margin: 20px 10px 0 0;
}
.Browser_li span {
  cursor: pointer;
  float: right;
  margin: 18px;
  color: #9f9f9f;
  height: 24px;
  border-radius: 50px;
  width: auto;
  padding: 0 6px;
  line-height: 24px;
  text-align: center;
  display: block;
  background: #00eec3;
  font-size: 12px;
  color: #000927;
}
.Website {
  float: left;
  width: 40%;
}
.Website .Website_con {
  font-size: 12px;
  color: #9f9f9f;
  margin: 30px auto;
  width: 90%;
}
.Website .Website_li {
  width: 90%;
  border: 1px solid #e1e3e6;
  border-radius: 12px;
  margin: 0 auto;
}
.Website .Website_li input {
  background: #f6f8fa;
  border: 1px solid #d5d7db;
  border-radius: 8px;
  width: 90%;
  margin: 0 auto;
  display: block;
  line-height: 36px;
  height: 36px;
  text-indent: 10px;
}
.Website .Website_li .Browser_title {
  text-indent: 5%;
}
.Website .Website_li .loginButton {
  width: 186px;
  line-height: 36px;
  height: 36px;
  font-size: 15px;
  margin: 20px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Website.vue